<template>
  <div class="users-style roster-general-settings">

        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance Settings<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance Settings / General Settings</span>
        </h4>
        <b-overlay :show="loading">
          <div class="ibox mt-4 pb-4">
            <div class="clearfix ibox-content">


            <div class="">
                <div class="row mb-2">
                    <div class="col-6 d-flex align-items-center justify-content-between">
                        <div class="ibox-title dashboard_title px-0">
                            <h4>General Settings</h4>
                        </div>
                    </div>
                    <div class="col-6">

                        <div class="d-flex align-items-center justify-content-between my-3">
                            <div class="approve-level-content p-0">
                                <div class="salary-heads">Enable Roster-Based Attendance Management System</div>
                                <small class="text-muted">Turn on Roster-Based Scheduling features.</small>
                            </div>
                            <toggle-button
                                v-model="roster_status"
                                @change="changeRosterStatus(roster_status)"
                                :sync="true"
                                :color="{ checked: '#004242', unchecked: '#e3342f', disabled: '#CCCCCC' }"
                            />
                        </div>

                    </div>
                </div>

            </div>
            <div class="row bg-wash mx-0 radius-8 pt-4 pb-2">
                <div class="col-6">

                    <div class="row">

                        <div class="col-sm-6">
                        <b-form-group  id="start_month-group" label="First Month of the Leave Year" label-for="start_month">
                            <b-form-select id="start_month" name="start_month" :disabled="disabled_by_acl" v-model="start_month" :options="months" ></b-form-select>
                        </b-form-group>
                        </div>
                        <div class="col-sm-6">
                        <b-form-group id="days_leave_year-group" label='Number of Days in Leave Year' label-for="days_leave_year">
                            <b-form-input id="days_leave_year" :disabled="disabled_by_acl" name="days_leave_year" v-model="days_leave_year"></b-form-input>
                        </b-form-group>
                        </div>
                    </div>

                    <div class="row custom-color-inputs">
                        <div class="col-sm-6">
                            <b-form-group id="weekend_color_code-group">
                                <b-form-input id="weekend_color_code" name="weekend_color_code" v-model="weekend_color_code" type="color"></b-form-input>
                                <label for="weekend_color_code" class="d-block px-3 pt-1 text-dark">Off Day Color Code</label>
                                <span class="d-block px-3 text-secondary font-medium pb-1">{{ weekend_color_code }}</span>
                            </b-form-group>
                        </div>
                        <div class="col-sm-6">
                            <b-form-group id="holiday_color_code-group">
                                <b-form-input id="holiday_color_code" name="holiday_color_code" v-model="holiday_color_code" type="color"></b-form-input>
                                <label for="holiday_color_code" class="d-block px-3 pt-1 text-dark">Holiday Color Code</label>
                                <span class="d-block px-3 text-secondary font-medium pb-1">{{ holiday_color_code }}</span>
                            </b-form-group>
                        </div>

                    </div>

                    <div class="row">
                      <div class="col-sm-6">
                          <b-form-group id="allow_grace_time_late_check_in-group" label-for="allow_grace_time_late_check_in">
                              <b-form-checkbox id="allow_grace_time_late_check_in" v-model="allow_grace_time_late_check_in" name="allow_grace_time_late_check_in" value="1" :disabled="disabled_by_acl">
                                  Grace Time (Late Clock In)
                              </b-form-checkbox>
                          </b-form-group>
                          <b-form-group id="grace_time_late_check_in-group" label="" label-for="grace_time_late_check_in" v-if="allow_grace_time_late_check_in">
                              <b-input-group append="Minutes">
                                  <b-form-input id="grace_time_late_check_in" name="grace_time_late_check_in" type="text" v-model="grace_time_late_check_in" :disabled="disabled_by_acl"></b-form-input>
                              </b-input-group>
                          </b-form-group>
                      </div>

                      <div class="col-sm-6">
                          <b-form-group id="allow_grace_time_early_checkout-group" label-for="allow_grace_time_early_checkout">
                              <b-form-checkbox id="allow_grace_time_early_checkout" v-model="allow_grace_time_early_checkout" name="allow_grace_time_early_checkout" value="1" :disabled="disabled_by_acl">
                                  Grace Time (Early Clock Out)
                              </b-form-checkbox>
                          </b-form-group>
                          <b-form-group id="grace_time_early_checkout-group" label="" label-for="grace_time_early_checkout" v-if="allow_grace_time_early_checkout">
                              <b-input-group append="Minutes">
                                  <b-form-input id="grace_time_early_checkout" name="grace_time_early_checkout" type="text" v-model="grace_time_early_checkout" :disabled="disabled_by_acl"></b-form-input>
                              </b-input-group>
                          </b-form-group>
                      </div>
                    </div>



                    <div class="row">
                      <div class="col-sm-6">
                      <b-form-group id="penalty_day-group" label-for="penalty_day" class="required-field">
                          <template #description>The selected day is used as the monthly period end date for penalty generation. </template>
                          <template #label>Penalty Generation Date &nbsp;<b-icon icon="info-circle" v-b-tooltip.hover.top="'If '+ penalty_day +' is selected, penalty records will be generated from the '+ (n => (n%100>=11&&n%100<=13)?n+'th':n+(['th','st','nd','rd'][n%10]||'th'))(parseInt(penalty_day)) +' day of the previous month to the '+ (n => (n%100>=11&&n%100<=13)?n+'th':n+(['th','st','nd','rd'][n%10]||'th'))(parseInt(penalty_day)-1) +' day of the current month.'"></b-icon></template>
                          <b-form-select id="penalty_day" name="penalty_day" v-model="penalty_day" :options="day_options"></b-form-select>
                      </b-form-group>
                      </div>
                      <div class="col-sm-6">
                      <b-form-group id="ot_day-group" label-for="ot_day" class="required-field">
                          <template #description>The selected day is used as the monthly period end date for penalty generation. </template>
                          <template #label>Overtime Generation Date &nbsp;<b-icon icon="info-circle" v-b-tooltip.hover.top="'If '+ ot_day +' is selected, overtime records will be generated from the '+ (n => (n%100>=11&&n%100<=13)?n+'th':n+(['th','st','nd','rd'][n%10]||'th'))(parseInt(ot_day)) +' day of the previous month to the '+ (n => (n%100>=11&&n%100<=13)?n+'th':n+(['th','st','nd','rd'][n%10]||'th'))(parseInt(ot_day)-1) +' day of the current month.'"></b-icon></template>
                          <b-form-select id="ot_day" name="ot_day" v-model="ot_day" :options="day_options"></b-form-select>
                      </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                          <b-form-group id="mindist-group" label="Minimum Distance For Punching From App" label-for="mindist" >
                              <b-input-group append="Meters">
                                  <b-form-input id="mindist" name="mindist" type="text" v-model="mindist" :disabled="disabled_by_acl"></b-form-input>
                              </b-input-group>
                          </b-form-group>
                      </div>
                    </div>
                </div>
                <div class="col-6">
                  <roster-module-access ref="rosterAccess"></roster-module-access>
                </div>

                <div class="text-center my-4 full-width" v-if="!disabled_by_acl">
                  <b-button variant="primary" @click="saveAttendanceSettings()" class="">Apply Changes</b-button>
                </div>
            </div>
              
            </div>

            <div class="row mb-3">
              <div class="col-12 col-md-2 col-lg-3"></div>
              <div class="col-12 col-md-8 col-lg-6">
                <div class="mt-4" v-if="!disabled_by_acl">
                  <div class="d-flex align-items-center justify-content-between py-2 pr-2 pl-3 rounded susd roster-general-setting-finalize">
                      <span class="text-muted">Finalize Carry For Last Leave Year And Unlock New Leave Year</span>
                      <b-button @click="leaveYearClosing()" variant="primary"> Finalize</b-button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-2 col-lg-3"></div>
            </div>
        </div>


      <b-modal id="change-roster-password-modal" title="Confirm Password" centered hide-footer @hide="onRosterPasswordHide">
        <p class="mb-2">Enter your password to change roster status.</p>
        <b-form-input type="password" v-model="password" placeholder="Password" autocomplete="current-password"></b-form-input>
        <b-button class="w-100 my-2" @click="changeRosterStatusApi(roster_status)">Confirm</b-button>
        <b-button class="w-100" @click="$bvModal.hide('change-roster-password-modal')">Cancel</b-button>
      </b-modal>
        </b-overlay>
    </div>
</template>
<script>
    export default{

        mounted() {

        },
        props: [],
        components: {
        },
        data(){

            return {
              roster_status: false,
              penalty_day: '',
              ot_day: '',
              password: '',
              loading: false,
                company_id : 0 ,
                months: [{ value: 1, text: "January" },{ value: 2, text: "February"},{ value: 3, text: "March"},{ value: 4, text: "April"},{ value: 5, text: "May"},{ value: 6, text: "June"},{ value: 7, text: "July"},{ value: 8, text: "August"},{ value: 9, text: "September"},{ value: 10, text: "October"},{ value: 11, text: "November"},{ value: 12, text: "December", } ],

                start_month : 1,
                days_leave_year : 365,
                supper_user : true,
                disabled_by_acl : false,
                off_day_on_leave : 0,
              week_start_day : 7,
              mindist: 30,
              weekend_color_code : '#aaaaaa',
              holiday_color_code : '#aaaaaa',
              connect_to_payroll_calculation : false,
              allow_grace_time_late_check_in : false,
              grace_time_late_check_in : 0,
              days_late_check_in : 0,

              allow_grace_time_early_checkout : false,
              grace_time_early_checkout : 0,


              options: [
                { text: 'Friday', value: '5' },
                { text: 'Saturday', value: '6' },
                { text: 'Sunday', value: '0' },
                { text: 'Monday', value: '1' },
                { text: 'Tuesday', value: '2' },
                { text: 'Wednesday', value: '3' },
                { text: 'Thursday', value: '4' }
              ],
            }
        },
        methods:{
          onRosterPasswordHide(){
            this.revertRosterStatus();
          },
          changeRosterStatus(roster_status){

            this.$bvModal.msgBoxConfirm('Change Roster-Based Leave Attendance System Settings?', {
              title: 'Please Confirm',
              okVariant: 'primary',
              okTitle: 'Confirm',
              cancelTitle: 'Cancel',
              centered: true
            }).then(confirmed => {
              if (!confirmed) {
                this.revertRosterStatus();
                return;
              }
              this.$bvModal.show('change-roster-password-modal');
            });
          },
          revertRosterStatus(){
            this.roster_status = !this.roster_status;
          },
          changeRosterStatusApi(roster_status) {
            let formData = new FormData();
            formData.append('roster_status', roster_status ? 1 : 0);
            formData.append('password', btoa(this.password));
            axios.post(this.$api_url+'/leave-attendance/settings/roster', formData).then((response) => {
                location.reload();
            }).catch(e => {
                this.serverError(e);
            });
          },

          formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            const yyyy = d.getFullYear();
            const mm = ('0' + (d.getMonth() + 1)).slice(-2);
            const dd = ('0' + d.getDate()).slice(-2);
            return `${yyyy}-${mm}-${dd}`;
          },
            getSettings : function()
            {
                axios.get(this.$api_url+'/leave-attendance/settings').then(function(response){
                    this.start_month = response.data.start_month;
                    this.days_leave_year = response.data.days_leave_year;
                    this.off_day_on_leave = response.data.off_day_on_leave;

                }.bind(this));
            },
          checkSuperUser : function()
          {
            axios.get(this.$api_url+'/user-type-level').then(function(response){
              if((response.data.user_type == '1') && (response.data.user_level == '1'))
                this.supper_user = true;

            }.bind(this));
          },

          getCompanyLeaveSettings:function()
          {
            if(!this.checkNet()) return false;
            axios.get(this.$api_url+'/leave-attendance/company/leave/settings').then(function(response){

              if(response.data.length != 0)
              {
                this.company_id =  response.data.company_id;
                this.mindist = response.data.mindist;
                this.weekend_color_code =  response.data.weekend_color_code;
                this.holiday_color_code =  response.data.holiday_color_code;
                this.connect_to_payroll_calculation =  response.data.connect_to_payroll_calculation;
                this.allow_grace_time_late_check_in =  response.data.allow_grace_time_late_check_in;
                this.grace_time_late_check_in =  response.data.grace_time_late_check_in;
                this.days_late_check_in =  response.data.days_late_check_in;

                this.allow_grace_time_early_checkout =  response.data.allow_grace_time_early_checkout;
                this.grace_time_early_checkout =  response.data.grace_time_early_checkout;
                this.roster_status = (response.data.roster == 1);
                this.penalty_day = response.data.penalty_day;
                this.ot_day = response.data.ot_day;
              }

            }.bind(this));

          },
          saveAttendanceSettings:function()
          {

            this.loading = true;
            let formData = new FormData();
            formData.append('start_month', this.start_month);
            formData.append('days_leave_year', this.days_leave_year);
            formData.append('off_day_on_leave', this.off_day_on_leave);
            formData.append('weekend_color_code', this.weekend_color_code);
            formData.append('holiday_color_code', this.holiday_color_code);
            formData.append('connect_to_payroll_calculation', this.connect_to_payroll_calculation);
            formData.append('allow_grace_time_late_check_in', this.allow_grace_time_late_check_in);
            formData.append('grace_time_late_check_in', this.grace_time_late_check_in);
            formData.append('days_late_check_in', this.days_late_check_in);
            formData.append('allow_grace_time_early_checkout', this.allow_grace_time_early_checkout);
            formData.append('grace_time_early_checkout', this.grace_time_early_checkout);
            formData.append('penalty_day', this.penalty_day);
            formData.append('ot_day', this.ot_day);
            formData.append('mindist', this.mindist);

            axios.post(this.$api_url+'/leave-attendance/leave/settings/save', formData,).then((response) => {
              this.$bvToast.toast('Saved!', {
                title: `Success`,
                variant: 'success',
                solid: true
              });
              this.loading = false;
              this.getSettings();
              location.reload();

              if(this.$refs.rosterAccess) {
                return this.$refs.rosterAccess.submitSettings();
              } else {
                return Promise.resolve();
              }

            }).catch((error) => {
                this.loading = false;
                this.serverError(error);
            });

          },
            leaveYearClosing:function()
            {
                this.loading = true;
                axios.post(this.$api_url+'/leave-attendance/leave/year/closing',).then((response) => {
                    this.loading = false;
                    this.$bvToast.toast(response.data.message || 'Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                }).catch((error) => {
                    this.loading = false;
                    this.serverError(error);
                });
            },



        },
        created: function(){
          this.getSettings();
          this.getCompanyLeaveSettings();
          this.checkSuperUser();
        },
        computed:
        {
          day_options: function () {
            let day_options = [];

            day_options.push({
              value: '00',
              text: 'Select Day'
            });

            for(var i = 1; i <= 28; i++)
            {
              var day = i;

              var label = i;

              

              if(i < 10)
              {
                label = '0' + i;
              }

              day_options.push({
                value: day,
                text: label
              });
            }
            day_options.push({
              value: 31,
              text: "End Of Month"
            });
            return day_options;
          }
        }
    }
</script>
